import { useRouteMatch } from "react-router-dom";
import { PATHS } from "modules/shared/constants/paths";

export const useIsParamRoute = () =>
  useRouteMatch({
    path: PATHS.USER,
    exact: false,
  });
